import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IEntityReducer } from 'core/reducers/entities';
import { ICertificate, ICertificateDAO } from 'types/domain/certificate';

const entity = (state: RootState) => state.entity.present;
const id = (state: RootState, id?: number) => (id ? id : state.state[EntityTypes.CERTIFICATE]);

export const selectCertificate = createSelector([entity, id], parseCertificateDAO);

export function parseCertificateDAO(entity: IEntityReducer, id: number) {
  const certificate: ICertificate = entity[EntityTypes.CERTIFICATE][id];

  if (!certificate) return null;

  return {
    ...certificate,
    text: certificate.textId ? entity[EntityTypes.TEXT][certificate.textId] : null,
    image: certificate.imageId ? entity[EntityTypes.IMAGE][certificate.imageId] : null,
    // variableGoals: getEntities(entity, EntityTypes.CERTIFICATE_VARIABLE, 'certificateId', certificate.id).map(
    //   (certVar: ICourseVariable) => {
    //     const variable = entity[EntityTypes.VARIABLE][certVar.variableId];
    //     return {
    //       ...certVar,
    //       variable: variable
    //         ? {
    //             ...variable,
    //             name: moduleVariableName(entity, variable) || variable.name,
    //             options: getEntities(entity, EntityTypes.VARIABLE_OPTION, 'variableId', variable.id),
    //           }
    //         : null,
    //     };
    //   },
    // ),
  } as ICertificateDAO;
}
